// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeController_inputRoot__twWPF","arrowIcon":"DateRangeController_arrowIcon__tb56f"};